import React, { Component } from 'react';
import format from 'string-format';
import moment from 'moment-timezone';
import AntConfig from '../utils/AntConfig';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';
import FilterBuilder from 'devextreme-react/filter-builder';
import AntGridBar from './old/AntGridBar_Old';

export default class extends Component {
    constructor(props) {
        super(props);

        var tableName =
            this.props.builderOptions && this.props.builderOptions.table
                ? this.props.builderOptions.table
                : this.props.table
                ? this.props.table
                : this.props.API.entityName;

        this.config = new AntConfig(this.props.session, tableName);
        this.config.configFields(
            this.props.builderOptions && this.props.builderOptions.fields instanceof Array ? this.props.builderOptions.fields : null
        );

        this.state = {
            tableName: tableName,
            value: this.props.value,
            pageIndex: 0,
            conditions: []
        };

        this.API = this.props.API;
    }

    render() {
        var formData = null;
        if (this.props.formRef) formData = this.props.formRef.option('formData');

        var fields = [];

        if (this.config && this.config.cnfFields instanceof Array) {
            this.config.cnfFields.forEach((fd) => {
                if (typeof fd === 'object' && fd.field && fd.canFilter !== false)
                    fields.push({
                        dataField: fd.field,
                        dataType: fd.dataType,
                        caption: fd.gridLabel ? AntLocalization.translateText(fd.gridLabel) : AntLocalization.translateText(fd.label)
                    });
            });
        }

        return (
            <React.Fragment>
                <FilterBuilder name={this.props.name} fields={fields} {...this.props.editorOptions} {...this.props.builderOptions} />
            </React.Fragment>
        );
    }
}
